



















































































import { Component, Mixins } from 'vue-property-decorator';
import { GPageBase } from '@/mixins';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import { schoolClassModule } from '@/store/modules/entities/school-class.module';
import GGroupDraggable from '@/components/GGroupDraggable.vue';
import draggable from 'vuedraggable';
import GSchoolClassesDraggable from '@/views/GSchoolClassChange/GSchoolClassesDraggable.vue';
import { GradeSchoolClass, SchoolClass } from '@/models/school-class/school-class';
import GClassImport from '@/views/GStudents/GClassImport.vue';
import { studentModule } from '@/store/modules/entities/student.module';
import { StudentSearch } from '@/models/student/student-search';
import GSchoolClassesTable from '@/views/GSchoolClasses/GSchoolClassesTable.vue';
import GSchoolClassEntryModal from '@/components/GSchoolClassesEntryModal.vue';
import GLoading from '@/components/GLoading.vue';
import { globalModule } from '@/store/modules/global.module';
import { Account } from '@/models/account';

Component.registerHooks(['beforeRouteLeave']);
@Component({
  name: 'GSchoolClasses',
  components: { GLoading, GSchoolClassEntryModal, GSchoolClassesTable, GClassImport, GSchoolClassesDraggable, GGroupDraggable, GCustomBreadCrumb, draggable },
  computed: {},
  methods: {},
})
export default class GSchoolClasses extends Mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  breadCrumbItemHome: BreadCrumbElement = null;
  newGrade: number = 1; // 追加した学年
  visiblePoptip: boolean = false; // 学年登録用ポップチップ
  initGradeSchoolClasses: GradeSchoolClass[] = []; // リセット、変更差分出力のための初期学年-クラスセット
  showTab: boolean = false; // タブ表示⇄非表示変換(タブ削除時にiViewで正しく動作しなくなるため、一旦v-ifを入れる)
  modalConfirm: boolean = false; // 更新確認モーダル
  modalClassImport: boolean = false; // クラス一括登録モーダル

  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.isUpdate) {
      // クラス編集時に別画面に遷移する場合は確認ダイアログを表示する
      this.$Modal.confirm({
        title: this.$t('CONFIRM_SCHOOL_CLASS_PAGE_LEAVE').toString(),
        onOk: () => {
          next();
        },
        onCancel: () => {
          return;
        },
      });
    } else {
      next();
    }
  }

  get account(): Account {
    return this.$store.state.account;
  }

  async created() {
    schoolClassModule.setGradeSchoolClasses([]);
    await schoolClassModule.fetchGradesSchoolClasses().then(() => {
      this.initGradeSchoolClasses = schoolClassModule.gradeSchoolClasses.map((gradeSchoolClass: GradeSchoolClass) => new GradeSchoolClass().deserialize(gradeSchoolClass));
    });
  }
  async mounted() {
    if (this.isOldSchoolYear) {
      this.breadCrumbItemHome = { title: this.$t('HOME').toString(), icon: 'ios-home' }; //リンクなし
    } else {
      this.breadCrumbItemHome = { title: this.$t('HOME').toString(), icon: 'ios-home', routerPath: '/pages/home' };
    }
    this.breadCrumbItems = [this.breadCrumbItemHome, { title: this.$t('MANAGE_SCHOOL_CLASS').toString(), icon: 'ios-home', routerPath: '/pages/schoolClasses' }];

    await studentModule.fetchStudents({
      limit: 0,
      offset: 0,
      hasScore: false,
    } as StudentSearch);

    this.showTab = true;
  }

  get isOldSchoolYear(): boolean {
    return globalModule.isOldSchoolYear;
  }

  get noSchoolClasses(): boolean {
    return this.schoolClassesByGrade.some((gradeSchoolClass: GradeSchoolClass) => {
      return gradeSchoolClass.schoolClasses.length === 0;
    });
  }

  get isUpdate(): boolean {
    return this.schoolClassesByGrade.some((gradeSchoolClass: GradeSchoolClass) => {
      return gradeSchoolClass.schoolClasses.some((schoolClass: SchoolClass) => {
        return schoolClass.changed || schoolClass.created || schoolClass.deleted;
      });
    });
  }

  get existGrade(): boolean {
    // タブに表示されている学年で、かつ、学年が一致している場合
    return this.schoolClassesByGrade.findIndex((gradeSchoolClass: GradeSchoolClass) => gradeSchoolClass.visible && gradeSchoolClass.grade === this.newGrade) > -1;
  }

  get schoolClassesByGrade(): GradeSchoolClass[] {
    return schoolClassModule.gradeSchoolClasses;
  }

  get includeBlankSchoolClassName(): boolean {
    return this.schoolClassesByGrade.some((gradeSchoolClass: GradeSchoolClass) => {
      return gradeSchoolClass.schoolClasses.some((schoolClass: SchoolClass) => schoolClass.schoolClassName === '');
    });
  }

  gradeTabLabel(grade: number, tabIndex: number): any {
    const isOldSchoolYear: boolean = this.isOldSchoolYear;
    return (h: any) => {
      return h('div', [
        h('span', `${grade}${this.$t('YEAR')}`),
        h('Badge', {
          props: {
            // 修正数(削除数+更新件数+追加件数)
            count: this.schoolClassesByGrade[tabIndex].schoolClasses.filter((schoolClass: SchoolClass) => schoolClass.changed || schoolClass.deleted || schoolClass.created).length,
          },
        }),
        this.account.isRoleIgsAdmin || (!isOldSchoolYear && !this.account.isRoleNormal)
          ? h('Icon', {
              props: {
                type: 'ios-close',
                size: 20,
              },
              style: {
                'margin-left': '10px',
              },
              on: {
                click: () => {
                  this.handleRemoveGrade(tabIndex);
                },
              },
            })
          : '',
      ]);
    };
  }

  handleRemoveGrade(tabIndex: number) {
    if (this.schoolClassesByGrade[tabIndex].schoolClasses.length === 0 || this.schoolClassesByGrade[tabIndex].schoolClasses.every((schoolClass: SchoolClass) => schoolClass.isNew)) {
      // 編集途中で追加した学年の場合は学年タブの表示を消してしまう
      schoolClassModule.removeGradeSchoolClasses(tabIndex);
      this.renderTab();
    } else {
      // すでに登録されているクラスは表示上は消さずに削除状態とする
      if (this.schoolClassesByGrade[tabIndex].schoolClasses.filter((s) => !this.includeStudents(s.schoolClassID)).every((schoolClass: SchoolClass) => schoolClass.deleted)) {
        this.schoolClassesByGrade[tabIndex].schoolClasses.forEach((schoolClass: SchoolClass) => {
          schoolClass.deleted = false;
        });
      } else {
        this.schoolClassesByGrade[tabIndex].schoolClasses.forEach((schoolClass: SchoolClass) => {
          if (this.includeStudents(schoolClass.schoolClassID)) {
            // すでに生徒が登録されているものは削除状態にできなくする
            return;
          }
          schoolClass.deleted = true;
        });
      }
    }
  }

  handleAddGrade() {
    schoolClassModule.insertGradeSchoolClasses(this.newGrade);
    this.newGrade = 1;
    this.visiblePoptip = false;
    this.renderTab();
  }

  renderTab() {
    this.showTab = false;
    setTimeout(() => {
      this.showTab = true;
    }, 1);
  }

  handleResetSchoolClasses() {
    // 値コピー
    schoolClassModule.setGradeSchoolClasses(this.initGradeSchoolClasses.map((gradeSchoolClass: GradeSchoolClass) => new GradeSchoolClass().deserialize(gradeSchoolClass)));
    this.renderTab();
  }

  includeStudents(schoolClassID: number) {
    return this.studentCountBySchoolClassID.has(schoolClassID) && this.studentCountBySchoolClassID.get(schoolClassID) > 0;
  }

  get studentCountBySchoolClassID(): Map<number, number> {
    return studentModule.studentCountBySchoolClassID;
  }
}
